import { render, staticRenderFns } from "./feedbackManage.vue?vue&type=template&id=55c95f80&"
import script from "./feedbackManage.vue?vue&type=script&lang=js&"
export * from "./feedbackManage.vue?vue&type=script&lang=js&"
import style0 from "./feedbackManage.vue?vue&type=style&index=0&id=55c95f80&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports